export default
  [
    {
      title: "Albanian",
      code: "sq"
    },
    {
      title: "Arabic",
      code: "ar"
    },
    {
      title: "Armenian",
      code: "hy"
    },
    {
      title: "Bulgarian",
      code: "bg"
    },
    {
      title: "Catalan",
      code: "ca"
    },
    {
      title: "Chinese",
      code: "zh"
    },
    {
      title: "Chuvash",
      code: "cv"
    },
    {
      title: "Danish",
      code: "da"
    },
    {
      title: "Dutch",
      code: "nl"
    },
    {
      title: "Estonian",
      code: "et"
    },
    {
      title: "Finnish",
      code: "fi"
    },
    {
      title: "French",
      code: "fr"
    },
    {
      title: "Galician",
      code: "gl"
    },
    {
      title: "Georgian",
      code: "ka"
    },
    {
      title: "German",
      code: "de"
    },
    {
      title: "Greek",
      code: "el"
    },
    {
      title: "Hebrew",
      code: "he"
    },
    {
      title: "Hindi",
      code: "hi"
    },
    {
      title: "Hungarian",
      code: "hu"
    },
    {
      title: "Icelandic",
      code: "is"
    },
    {
      title: "Irish",
      code: "ga"
    },
    {
      title: "Italian",
      code: "it"
    },
    {
      title: "Japanese",
      code: "ja"
    },
    {
      title: "Korean",
      code: "ko"
    },
    {
      title: "Kurdish",
      code: "ku"
    },
    {
      title: "Latvian",
      code: "lv"
    },
    {
      title: "Lithuanian",
      code: "lt"
    },
    {
      title: "Macedonian",
      code: "mk"
    },
    {
      title: "Manx",
      code: "gv"
    },
    {
      title: "Moldavian",
      code: "mo"
    },
    {
      title: "Northern Sami",
      code: "se"
    },
    {
      title: "Norwegian",
      code: "no"
    },
    {
      title: "Persian",
      code: "fa"
    },
    {
      title: "Polish",
      code: "pl"
    },
    {
      title: "Portuguese",
      code: "pt"
    },
    {
      title: "Romanian",
      code: "ro"
    },
    {
      title: "Russian",
      code: "ru"
    },
    {
      title: "Sardinian",
      code: "sc"
    },
    {
      title: "Serbian",
      code: "sr"
    },
    {
      title: "Slovak",
      code: "sk"
    },
    {
      title: "Slovenian",
      code: "sl"
    },
    {
      title: "Spanish",
      code: "es"
    },
    {
      title: "Swedish",
      code: "sv"
    },
    {
      title: "Thai",
      code: "th"
    },
    {
      title: "Tonga (Tonga Islands)",
      code: "to"
    },
    {
      title: "Turkish",
      code: "tr"
    },
    {
      title: "Ukrainian",
      code: "uk"
    },
    {
      title: "Welsh",
      code: "cy"
    }
  ]



/** WEBPACK FOOTER **
 ** ./src/lib/languages.js
 **/